export const MODAL_TYPE_DISCARD_POST = 'discard-post';
